import { FetchPageDataReducerState } from './types';

export const getDefaultState = (): FetchPageDataReducerState => ({
  pages: {}
});
